// Properties.jsx
import React, { useEffect, useState } from "react"; 
import { useLocation } from "react-router-dom";
import { sanityClient, urlFor } from "../client";
import { BiBed, BiMap, BiMapAlt, BiBath } from "react-icons/bi";
import { Link } from "react-router-dom";
import CardHoverIcons from "../components/common/page-componets/CardHoverIcons";
import CardLabels from "../components/common/page-componets/CardLabels";

const Properties = () => {
  const [properties, setProperties] = useState([]);
  const { search } = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(search);

    const address = searchParams.get("address");
    const propertyType = searchParams.get("propertyType");
    const price = searchParams.get("price");
    const category = searchParams.get("category");

    const query = `*[_type == "properties"
      ${address ? '&& address match $address' : ''}
      ${propertyType ? '&& propertyType == $propertyType' : ''}
      ${price ? '&& price == $price' : ''}
      ${category ? '&& category == $category' : ''}
    ]{
      _id, propertyName, slug, propertyType, category, address, city,
      bedrooms, bathrooms, price, description, images, plotSize, status, createdAt
    }`;

    const params = { address, propertyType, price, category };

    sanityClient
      .fetch(query, params)
      .then((data) => {
        setProperties(data);
      })
      .catch((error) => {
        console.error("Sanity fetch error:", error);
      });
  }, [search]);

  return (
    <div className="pt-10 pb-16">
      <div className="text-center">
        <h1 className="mx-auto sub-heading">featured</h1>
        <h1 className="heading">explore featured latest properties</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
        { properties.length === 0 ? (
          <div className="col-span-full text-center py-10">
            <h2 className="text-2xl font-semibold text-gray-500 dark:text-gray-400">
              No properties found. Please adjust your filters or try again later.
            </h2>
          </div>
          ) : (
          properties.map((property) => (
          <div
            key={property.slug?.current || property._id}
            className="flex-1 basis-[18rem] shadow-light dark:border-card-dark border rounded-lg overflow-hidden relative group"
          >
            <div className="overflow-hidden relative">
              <Link to={`/property/${property.slug?.current}`} className="!opacity-100">
                {property.images?.length > 0 && (
                  <img
                    src={urlFor(property.images[0]).width(300).url()}
                    alt={property.propertyName}
                    className="w-full h-fit md:h-[250px] object-cover group-hover:scale-110 transition-all"
                  />
                )}
              </Link>
              <CardHoverIcons />
              <div className="absolute bottom-0 left-0 w-full px-2 py-2 transition-transform bg-gradient-to-t from-black/80 sm:translate-y-10 group-hover:translate-y-0 to-transparent">
                <div className="text-white flex items-center gap-x-2">
                  <BiMap />
                  <p>{property.city}, {property.address}</p>
                </div>
              </div>
            </div>
            <CardLabels purpose={property.category} distance={property.propertyType} />
            <div className="p-3">
              <Link to={`/property/${property.slug?.current}`} className="group-hover:text-primary transition-all">
                <h1 className="text-lg font-bold capitalize">{property.propertyName}</h1>
              </Link>
              <div className="flex justify-between mt-3">
                <div className="flex items-center gap-x-2">
                  <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                    <BiBed />
                  </div>
                  <p className="text-sm">{property.bedrooms} Beds</p>
                </div>
                <div className="flex items-center gap-x-2">
                  <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                    <BiBath />
                  </div>
                  <p className="text-sm">{property.bathrooms} Bathrooms</p>
                </div>
                <div className="flex items-center gap-x-2">
                  <div className="icon-box w-7 h-7 bg-primary/20 hover:bg-primary/40 text-primary flex items-center justify-center rounded-full">
                    <BiMapAlt />
                  </div>
                  <p className="text-sm">{property.status}</p>
                </div>
              </div>
              <div className="mt-4 flex justify-between items-center">
                <h1 className="text-lg font-semibold text-primary">{property.price}</h1>
                <Link to={`/properties/${property.slug?.current}`} className="btn btn-secondary">
                  Details
                </Link>
              </div>
            </div>
          </div>
        )))}
      </div>
    </div>
  );
};

export default Properties;
